import secureApi from "../services/secureApi";


  //  GET MENU LIST
export const getMenus = async ({ search = "", sort = "desc" } = {}) => {
  try {
    const params = { sort };

    if (search?.trim()) {
      params.search = search.trim();
    }

    const response = await secureApi.get("/menu/list", {
      params,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

  // GET MENU BY ID
export const getMenuById = async (id) => {
  try {
    const response = await secureApi.get(
      `/menu/view/${id}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};


  // ADD MENU
export const createMenu = async (data) => {
  try {
    const response = await secureApi.post(
      "/menu/add",
      data
    );

    return response.data;
  } catch (error) {
    
    throw error;
  }
};


   //UPDATE MENU

export const updateMenu = async (id, data) => {
  try {
    const response = await secureApi.put(
      `/menu/edit/${id}`,
      data
    );

    return response.data;
  } catch (error) {
  
    throw error;
  }
};

  // DELETE MENU 
export const deleteMenu = async (id) => {
  try {
    const response = await secureApi.delete(
      `/menu/delete/${id}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};